import React, { Fragment } from 'react';
import css from './NivoHelpers.module.css';

export const axisRight = { orient: 'right', tickValues: [] };

export const theme = {
	axis: {
		domain: {
			line: {
				stroke: '#E1E1E1',
				strokeWidth: 1,
			},
		},
		ticks: {
			line: {
				stroke: '#ABA7A7',
			},
			text: {
				fill: '#ABA7A7',
				fontSize: 11,
			},
		},
		legend: {
			text: {
				fill: '#ABA7A7',
			},
		},
	},
};

// Custom Tooltips
// ------------------------------------------------------

export const getToolTip = (label, num) => {
	return (
		<div className={css.tooltip}>
			<label>{label}</label>
			<span>{num}</span>
		</div>
	);
};

// Custom Layer Functions
// ------------------------------------------------------

export const YearLinesLayer = ({ axisBottom, weeks, minY, maxY, xScale, yScale }) => {
	let d = '';
	for (let i = 0; i < axisBottom.tickValues.length; i++) {
		const weekIdx = axisBottom.tickValues[i];
		if (weeks[weekIdx].endsWith('-01')) {
			const x = xScale(weekIdx);
			const y1 = yScale(minY);
			const y2 = yScale(maxY);
			d += `M ${x} ${y1} V ${y2} `;
		}
	}
	return <path d={d} className={css.yearLine} />;
};

export const BaseLineLayer = ({ range, weeks, baseline, xScale, yScale }) => {
	let d = '';
	for (let i = range.min; i <= range.max; i++) {
		if (baseline[i]) {
			d += (i === range.min ? 'M ' : 'L ') + xScale(i) + ' ' + yScale(baseline[i]);
		}
	}
	return <path d={d} className={css.baseLine} />;
};

// Draws a line from left to right at 0 on the y axis
// as determined by the first datasets first and last x value
export const ZeroLineLayer = ({ minX, maxX, minY, xScale, yScale }) => {
	if (minY < 0) {
		const y = yScale(0);
		const x1 = xScale(minX);
		const x2 = xScale(maxX);
		return <line x1={x1} y1={y} x2={x2} y2={y} className={css.zeroLine} />;
	}
};

// Draw the normal range around a data point
export const NormalRangeLayer = ({ hnr, lnr, range, xScale, yScale, innerHeight }) => {
	const points = [];
	for (let i = range.min; i <= range.max; i++) {
		points.push(`${xScale(i)},${yScale(hnr[i])}`);
	}
	for (let i = range.max; i >= range.min; i--) {
		points.push(`${xScale(i)},${yScale(lnr[i])}`);
	}

	return <polygon points={points.join(' ')} className={css.normalRange} />;
};

// Draws horizontal normal ranges and substantial increases on zscore graphs
export const ZScoreHorizontalLayers = ({ minX, maxX, xScale, yScale }) => {
	const x1 = xScale(minX);
	const x2 = xScale(maxX);
	const points = `${x1} ${yScale(-2)} ${x2} ${yScale(-2)} ${x2} ${yScale(2)} ${x1} ${yScale(2)}`;
	return (
		<Fragment>
			<polygon points={points} className={css.normalRange} />;
			<line x1={x1} y1={yScale(0)} x2={x2} y2={yScale(0)} className={css.baseLine} />
			<line x1={x1} y1={yScale(4)} x2={x2} y2={yScale(4)} className={css.substantialLine} />
		</Fragment>
	);
};

// Draws a yellow uncertainty rectangle for the last three weeks of data
// for a graph. It expects each data point in the x-axis to be a week number idx
const uncertaintyWeeks = 4;

export const UncertaintyLayer = ({ weeks, series, minY, maxY, maxX, xScale, yScale }) => {
	if (!series || series.length === 0 || !series[0].data) {
		return null;
	}
	const l = series[0].data.length;
	if (l < 1) {
		return null;
	}
	const beginUncertaintyIdx = weeks.length - 1 - uncertaintyWeeks;
	let showWeeksBack = -1;
	for (let i = 0; i < uncertaintyWeeks; i++) {
		if (!series[0].data[l - 1 - i] || series[0].data[l - 1 - i].data.x <= beginUncertaintyIdx) {
			break;
		}
		showWeeksBack = i;
	}
	if (showWeeksBack > 0) {
		const x = series[0].data[l - 1 - showWeeksBack].position.x;
		const y = yScale(maxY);
		const w = xScale(maxX) - x;
		const h = yScale(minY) - y;
		return <rect x={x} y={y} width={w} height={h} className={css.uncertainty} />;
	}
};
